// Open a URL in a new browser tab.
//
// Note on "noopener": passing it in the features string makes the browser return
// null even on success, because the opener link is deliberately severed. Using it
// here meant every successful open looked like a blocked pop-up. The opener is
// cleared on the returned window instead, which keeps the same protection while
// still telling us whether the tab actually opened.
export const openInNewTab = (url: string): boolean => {
  const newWindow = window.open(url, "_blank");
  if (!newWindow) return false;   // genuinely blocked
  try {
    newWindow.opener = null;
  } catch (error) {
    // some browsers disallow the assignment; the tab is open either way
  }
  newWindow.focus();
  return true;
};
